module.exports = __webpack_public_path__ + "33373a905371fa0869d43e63563e6f2f.svg";